import React from "react";

/** @type {React.Context<Partial<import("../../../../../../types/store").CloseAccountContextProps>>} */
const CloseAccountContext = React.createContext({ });

export const CloseAccountProvider = CloseAccountContext.Provider;

export default CloseAccountContext;
